import { ExportOption } from 'routes/AccessFunction/containers/AccessFunctionList/components/DialogBody/ExportReportDialogBody';
import exportWiretaps from './wiretaps.api';

export const exportWiretapsToFile = async (
  filterCriteria: string,
  exportOption: ExportOption
) => {
  try {
    const response = await exportWiretaps(0, filterCriteria);
    // Create a URL for the file and download it
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const filename = `${exportOption.filename}.${exportOption.fileFormat}`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to export wiretaps:', error);
    return false;
  }
};

export default exportWiretapsToFile;
